const actions = {
  SET_FAV_LISTINGS: "SET_FAV_LISTINGS",
  ADD_FAV_LISTING: "ADD_FAV_LISTING",
  REMOVE_FAV_LISTING: "REMOVE_FAV_LISTING",
  SET_USER_LIKES: "SET_USER_LIKES",
  ADD_LIKE: "ADD_LIKE",
  REMOVE_LIKE: "REMOVE_LIKE",
  SET_FETCH_LIKES_COMPLETED: "SET_FETCH_LIKES_COMPLETED",
  setFavListings: (payload) => ({
    type: actions.SET_FAV_LISTINGS,
    payload,
  }),
  addFavListing: (payload) => ({
    type: actions.ADD_FAV_LISTING,
    payload,
  }),
  removeFavListing: (payload) => ({
    type: actions.REMOVE_FAV_LISTING,
    payload,
  }),
  setUserLikes: (payload) => ({
    type: actions.SET_USER_LIKES,
    payload,
  }),
  addLike: (payload) => ({
    type: actions.ADD_LIKE,
    payload,
  }),
  removeLike: (payload) => ({
    type: actions.REMOVE_LIKE,
    payload,
  }),
  setFetchLikesCompleted: (payload) => ({
    type: actions.SET_FETCH_LIKES_COMPLETED,
    payload,
  }),
};

export default actions;
